<div class="agpr-tableOfContent" role="radiogroup">
    <agpr-checkbox
        id="tableOfContents_includeTitles_checkbox"
        class="agpr-tableOfContentCheckbox"
        label="Briefings.fields.tableOfContent.includeTitles"
        [binary]="true"
        [(ngModel)]="includeTitle"
        (ngModelChange)="handleChange()"
    >
    </agpr-checkbox>

    @if(includeTitle) {
        <div class="agpr-tableOfContent-titleLevelContainer">
            <agpr-dropdown
                id="tableOfContents_titleLevel_dropdown'"
                label="Briefings.fields.tableOfContent.showLevels"
                [options]="dropdownLevelOptions"
                [(ngModel)]="selectedTitleLevel"
                (ngModelChange)="handleChange()"
            ></agpr-dropdown>
        </div>
    }

    <agpr-checkbox
        id="tableOfContents_includeMentionSections_checkbox"
        class="agpr-tableOfContentCheckbox"
        label="Briefings.fields.tableOfContent.includeMentionSections"
        [binary]="true"
        [(ngModel)]="includeMentionSections"
        (ngModelChange)="handleChange()"
    >
    </agpr-checkbox>

    <agpr-checkbox
        id="tableOfContents_includeMentionCount_checkbox"
        class="agpr-tableOfContentCheckbox"
        label="Briefings.fields.tableOfContent.includeMentionCount"
        [binary]="true"
        [(ngModel)]="includeMentionCount"
        (ngModelChange)="handleChange()"
    >
    </agpr-checkbox>

    <agpr-radio
        id="tableOfContents_orientation_horizontal"
        class="agpr-tableOfContentRadioButton"
        label="Briefings.fields.tableOfContent.horizontalLayout"
        hiddenLabel="Briefings.fields.tableOfContent.horizontalLayout"
        [name]="'selectedOrientation'"
        [(ngModel)]="selectedOrientation"
        [value]="tableOfContentOrientationEnum.horizontal"
        (ngModelChange)="orientationChange()"
    ></agpr-radio>

    <agpr-radio
        id="tableOfContents_orientation_vertical"
        class="agpr-tableOfContentRadioButton"
        label="Briefings.fields.tableOfContent.verticalLayout"
        hiddenLabel="Briefings.fields.tableOfContent.verticalLayout"
        [name]="'selectedOrientation'"
        [(ngModel)]="selectedOrientation"
        [value]="tableOfContentOrientationEnum.vertical"
        (ngModelChange)="orientationChange()"
    ></agpr-radio>
    <div
        *ngIf="selectedOrientation === tableOfContentOrientationEnum.vertical"
        class="agpr-tableOfContentOptions"
    >
        <agpr-checkbox
            id="tableOfContents_verticalIncludeHeadlines_checkbox"
            class="agpr-tableOfContentCheckbox"
            [label]="'Briefings.fields.tableOfContent.includeHeadlines' | localize"
            [binary]="true"
            [(ngModel)]="includeHeadlines"
            (ngModelChange)="handleChange()"
        >
        </agpr-checkbox>
    </div>
</div>
